import { MDBContainer } from "mdb-react-ui-kit";
import { FC, useState } from "react";
import { useIsSM } from "@/utils/hooks/useWindowSizes";
import { useShouldRenderArrayFC } from "@/hooks/useShouldRenderArrayFC";
import { convertDeltaToHtmlConverter } from "@/utils/common/delta";
import HomeHeadDetailMobile from "./HomeHeadDetailMobile";
import HomeHeadDetailDesktop from "./HomeHeadDetailDesktop";
import SmartSeachModal from "../smartSearch/SmartSearchModal";
import HeroSearchBar from "./HeroSearchBar";
import {
    DestinationToExploreEntity,
    Section,
    ToursByTourTypeEntity,
} from "../../../models/home";
import styles from "../../../styles/home/Home.module.scss";

const HomeHead: FC<{
    smartSearchContent?: ToursByTourTypeEntity[];
    destinationToExplore?: DestinationToExploreEntity[] | null;
    headImage: string;
    altHeadImage?: string;
    bannerHome?: Section;
}> = ({
    smartSearchContent,
    destinationToExplore,
    headImage,
    altHeadImage,
    bannerHome,
}) => {
    const [showModal, setShowModal] = useState(false);
    const [isSearchFocused, setIsSearchFocused] = useState(false);
    const isSM = useIsSM();

    const destinationExist = useShouldRenderArrayFC(destinationToExplore);
    const smartSearchContentExist = useShouldRenderArrayFC(smartSearchContent);

    return (
        <MDBContainer fluid className={styles.homeHead}>
            {isSearchFocused && (
                <div
                    className={styles.searchOverlay}
                    onClick={() => setIsSearchFocused(false)}
                />
            )}
            <div
                className={`${styles.homeHeadBgImg} ${
                    isSearchFocused ? styles.homeHeadBgImgSearchActive : ""
                }`}
                title={altHeadImage}
                style={{
                    backgroundImage: `url(${headImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center top",
                    backgroundRepeat: "no-repeat",
                }}
            >
                <div className={styles.homeHeadTitle}>
                    <div className="m-0">
                        {bannerHome?.title ? (
                            <h1
                                className="mb-2"
                                dangerouslySetInnerHTML={{
                                    __html: convertDeltaToHtmlConverter(
                                        bannerHome?.title
                                    ),
                                }}
                            />
                        ) : (
                            <h1 className="mb-2"> </h1>
                        )}
                        {bannerHome?.subtitle ? (
                            <h2
                                dangerouslySetInnerHTML={{
                                    __html: convertDeltaToHtmlConverter(
                                        bannerHome?.subtitle
                                    ),
                                }}
                            />
                        ) : (
                            <h2> </h2>
                        )}
                    </div>
                    <div className={styles.heroSearchWrapper}>
                        <HeroSearchBar onFocusChange={setIsSearchFocused} />
                    </div>
                    {isSM && <HomeHeadDetailMobile />}
                </div>
            </div>
            <div
                className={`${styles.headLowerContainer} d-flex justify-content-center`}
            >
                {!isSM && (
                    <div className={styles.headLowerContentContainer}>
                        <HomeHeadDetailDesktop />
                    </div>
                )}
            </div>
            {destinationExist && smartSearchContentExist && (
                <SmartSeachModal
                    content={smartSearchContent!}
                    show={showModal}
                    setShow={setShowModal}
                    destinationToExplore={destinationToExplore!}
                />
            )}
        </MDBContainer>
    );
};

export default HomeHead;
